import React from "react";
import * as ROUTES from "../constants/routes";
import { Button, Container, Header, HeaderNav, Row } from "../components";

const HeaderContainer: React.FC = () => (
  <HeaderNav>
    <Container>
      <Row flexFin>
        <HeaderNav.Toggler>
          <HeaderNav.Humberger />
        </HeaderNav.Toggler>
        <HeaderNav.Nav>
          <HeaderNav.Inner>
            <HeaderNav.Page name={ROUTES.HOME}>Home</HeaderNav.Page>
            <HeaderNav.Page name={ROUTES.ABOUT}>About</HeaderNav.Page>
            <HeaderNav.Page name={ROUTES.PORTFOLIO}>Portfolio</HeaderNav.Page>
            <HeaderNav.Page name={ROUTES.CONTACT}>Contact</HeaderNav.Page>
          </HeaderNav.Inner>
        </HeaderNav.Nav>
      </Row>
    </Container>
  </HeaderNav>
);

export default HeaderContainer;
